import { CustomLayerProps, Point, Serie } from '@nivo/line'

import { ChartData } from 'modules/finance/components/FinancialWorkspace/components/Table/types'

import { NULL_SERIES_PREFIX, findHoveredPoints, isStartOrEndPoint } from './helpers'

const CustomHoverLayer = (
  hoveredPoint: Point | null,
  chartData: ChartData[] | undefined,
  series: Serie[]
) => {
  const Component = ({ points }: CustomLayerProps) => {
    const hoveredPoints = findHoveredPoints(hoveredPoint, series)

    return (
      <>
        {points
          .filter((point) => !`${point.serieId}`.includes(NULL_SERIES_PREFIX))
          .map((point) => {
            if (isStartOrEndPoint(point)) return null

            const baseSize = 2.5
            const isHoveredPoint = hoveredPoints.find(
              ({ x, y }) => x === point.data.x && y === point.data.y
            )

            const category = (chartData || []).find((obj) => obj.serieId === point.id.split('.')[0])

            return (
              <circle
                cx={point.x}
                cy={point.y}
                key={point.id}
                strokeWidth={1}
                r={baseSize * (isHoveredPoint ? 1.5 : 1)}
                fill={isHoveredPoint ? category?.hoveredPointColor : category?.pointColor}
                stroke={isHoveredPoint ? category?.hoveredPointColor : category?.pointColor}
              />
            )
          })}
      </>
    )
  }

  return Component
}

export { CustomHoverLayer }
